<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<div class="container-fluid p-0">
  <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">

      {#each blocklist(block, 'slides') as item, i}
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="{i}" class={i==0 ? "active" : ""} aria-current="true" aria-label="Slide {i}"></button>
      {/each}

    </div>
    <div class="carousel-inner">

      {#each blocklist(block, 'slides') as item, i}
      <div class="carousel-item {i==0 ? 'active' : ''}"
           style="background: center / cover no-repeat url('{image(item, 'bg', [1500, null])}')">
        <div class="carousel-caption text-start">
          <h1>{text(item, 'headline')}</h1>
          <p>{text(item, 'main')}</p>
          <p><a class="btn btn-lg btn-primary" href="{url(item, 'button')}" use:link>{text(item, 'button')}</a></p>
        </div>
      </div>
      {/each}

    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</div>

<style>
  /* Carousel base class */
  .carousel {
      margin-bottom: 4rem;
  }
  /* Since positioning the image, we need to help out the caption */
  .carousel-caption {
      bottom: 3rem;
      z-index: 10;
  }

  /* Declare heights because of positioning of img element */
  .carousel-item {
      height: 32rem;
  }
  .carousel-item > img {
      position: absolute;
      top: 0;
      left: 0;
      min-width: 100%;
      height: 32rem;
  }
</style>
